import { FC } from 'react';
import Typography from '@components/common/typography';
import VerificationCode from '@components/verification_code';
import styles from './styles.module.scss';
import { IModalComponentProps } from '@context/modal_context';

const VerifyCardActivationModal: FC<IModalComponentProps<{ first_6_digits: string }>> = ({
    modalData,
    changeModalData
}) => {
    return (
        <div className={styles.wrapper}>
            <Typography variant="h4" className={styles.title}>
                Activate card
            </Typography>
            <Typography variant="body3" className={styles.description}>
                To complete activation, enter the first 6 digits of your card number
            </Typography>
            <div className={styles.content}>
                <VerificationCode
                    onChange={(value) => changeModalData({ ...modalData, first_6_digits: value })}
                    value={modalData?.first_6_digits}
                />
            </div>
        </div>
    );
};

export default VerifyCardActivationModal;
